"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _default = exports.default = {
  // 引入方式 import CustomSyncDataModal from '@ys/micro-components/CustomSyncDataModal'
  name: 'CustomSyncDataModal',
  // 更新/导出数据模态框组件
  props: {
    // 按钮文字
    btnTitle: {
      type: String,
      default: '更新数据'
    },
    // 按钮属性
    btnProps: {
      type: Object,
      default: () => {}
    },
    // 模态框标题
    modalTitle: {
      type: String,
      default: undefined
    },
    // 选择日期Form.Item的label
    dateLabel: {
      type: String,
      default: '选择日期范围'
    },
    // 选择日期Form.Item的extra描述
    dateDesc: {
      type: String,
      default: undefined
    },
    // 是否需要选择店铺
    needShopNo: {
      type: Boolean,
      default: false
    },
    // 店铺是否必选
    shopNoRequired: {
      type: Boolean,
      default: false
    },
    // 选择店铺Form.Item的extra描述
    shopDesc: {
      type: String,
      default: undefined
    },
    // 返回的字段
    fields: {
      type: Array,
      default: () => ['startDate', 'endDate']
    },
    // 能选择的最近天数，如：只能选择最近90天之内的日期，0表示不受限
    dateSpan: {
      type: Number,
      default: 90
    },
    // 开始日期和结束日期之间的天数跨度，0表示不受限
    dateRange: {
      type: Number,
      default: 90
    },
    // 额外传入的请求参数
    params: {
      type: Object,
      default: () => {}
    },
    // 点击“确定”按钮时的请求方法
    // 如果需要在请求成功后，下载接口返回的文件流，需要配置{ responseType: 'blob', originalData: true }，
    // 如：export const getOrderExport = (params) => axios.get('/v1/dw/order/export', params, { responseType: 'blob', originalData: true })
    method: {
      type: Function,
      required: true
    },
    // rangePicker的props配置
    rangePickerProps: {
      type: Object,
      default: undefined
    },
    // shopLevel的props配置
    shopLevelProps: {
      type: Object,
      default: undefined
    }
  },
  data() {
    // 时间范围校验
    const validateRangeDate = (rule, value, callback) => {
      if (_.isEmpty(value)) {
        callback(new Error('请选择日期'));
      } else if (this.dateRange > 0 && value[1].diff(value[0], 'day') + 1 > this.dateRange) {
        callback(new Error(`此处选择的时间范围不能超过${this.dateRange}天`));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      confirmLoading: false,
      selectedLevel: undefined,
      form: {
        rangeDate: [],
        shopNo: undefined
      },
      rules: {
        rangeDate: [{
          validator: validateRangeDate,
          required: true,
          trigger: 'change'
        }],
        shopNo: [{
          required: this.shopNoRequired,
          message: '请选择店铺',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    afterClose() {
      this.form.rangeDate = [];
      this.form.shopNo = undefined;
      this.selectedLevel = undefined;
    },
    disabledDate(current) {
      const min = (0, _moment.default)().subtract(this.dateSpan, 'days');
      const max = (0, _moment.default)();
      if (this.dateSpan === 0) return current > max;
      return current < min || current > max;
    },
    handleOk() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const [value0, value1] = this.form.rangeDate;
            const {
              format = 'YYYY-MM-DD'
            } = this.rangePickerProps || {};
            const params = _.merge({
              [this.fields[0]]: (0, _moment.default)(value0).format(format),
              [this.fields[1]]: (0, _moment.default)(value1).format(format)
            }, this.form, this.params);
            delete params.rangeDate;
            this.confirmLoading = true;
            const {
              data,
              headers
            } = await this.method(params);
            // 如果是 Blob 类型，意味着接口返回二进制流，需下载。
            if (data instanceof Blob) {
              const contentDisposition = headers['content-disposition'] || '';
              const arr = contentDisposition.match(/filename=(\S*)/);
              const filename = arr ? arr[1] : `${new Date().toLocaleDateString().replace(/\//g, '')}.xlsx`;
              this.$m.file.downloadFile(data, filename);
            } else {
              this.$message.success('请求成功');
            }
            this.$emit('ok');
            this.confirmLoading = false;
            this.visible = false;
          } catch (e) {
            this.confirmLoading = false;
          }
        }
      });
    }
  }
};